module.exports = __webpack_public_path__ + "img/dhfesta_logo_eng3.fbbc2d50.png";